import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pending-fill",
  "use": "icon-pending-fill-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 17 16\" id=\"icon-pending-fill\"><path fill=\"#FFAB00\" fill-rule=\"evenodd\" d=\"M15.5 8a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-6.267.033a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0m2.3.7a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m-5.3-.7a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol